import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect } from "react";
import { generateUniqueId } from "../../../store/utility";

const QuillEditor = (props) => {
  useEffect(() => {
    try {
      let editors = document.getElementsByClassName("ql-editor");

      for (let i = 0; i < editors.length; i++) {
        let editor = editors[i];
        editor.style.maxHeight = "30rem";
      }
    } catch (error) {}
  }, []);
  let toolbarConfig = [
    // [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    // [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ];
  const quillmodules = {
    toolbar: props.toolbar ? toolbarConfig : false,

    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };
  /*
   * Quill editor formats
   * See https://quilljs.com/docs/formats/
   */
  const quillformats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  const value = props.value;
  const theme = props.theme;
  return (
    <>
      <ReactQuill
        key={generateUniqueId(10)}
        theme={"snow"}
        value={value}
        // onChange={(value)=> setProduct({ ...inputProduct, productDesc: value }) }
        onChange={(t) => {
          if (value !== t) {
            // console.log(t)
            props.setValue(t);
          }
        }}
        modules={quillmodules}
        formats={quillformats}
        // style={{ overflow: "scroll", maxHeight: "30rem" }}
      />
    </>
  );
};

export default QuillEditor;
